import React, { useState, useRef, useEffect } from "react";
import emailjs from "@emailjs/browser";
import { Link } from "react-router-dom";
// Updated Imports: Import db and auth from your existing firebase.js
import { db, auth } from "../firebase"; 
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import "./ContactUs.css";
import SocialSidebar from "../components/SocialSideBar";
import { FaSearch, FaFilter, FaWhatsapp, FaQuestionCircle } from "react-icons/fa";
import Footer from "./Footer";


const ContactUs = () => {
  // --- CONFIGURATION CONSTANTS (Moved inside component for scoping) ---
  const STREAMS = ["Science (PCM)","Science (PCB)", "Commerce", "Humanities/Arts", "Other"];
  const CLASSES = ["Dropper", "Class 12th", "Class 11th", "Class 10th", "Class 9th", "Class 8th","Class 7th","Class 6th", "Parent/Guardian"];
  const REGARDING_OPTIONS = ["Test Series", "IIT-JEE Preparation", "NEET Preparation", "Board Exams (6-12th)", "Pricing / Fees", "Personal Mentorship", "Other Query"];

  const [formData, setFormData] = useState({ 
    firstName: "", 
    lastName: "",
    phone: "",
    email: "", 
    class: CLASSES[0], 
    stream: STREAMS[0], 
    regarding: REGARDING_OPTIONS[0],
    message: "" 
  });
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isSending, setIsSending] = useState(false);
  const sendingRef = useRef(null);

  // Removed useEffect for manual Firebase sign-in/initialization, 
  // relying instead on imported `auth` instance from `../firebase`.

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");
    setIsSending(true);

    if (sendingRef.current) {
      sendingRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
    
    // 1. Prepare data
    const fullName = `${formData.firstName} ${formData.lastName}`;
    
    // Use a placeholder or anonymous ID if auth is still resolving or not available
    const userId = auth?.currentUser?.uid || 'anonymous-' + crypto.randomUUID(); 
    
    const submissionData = {
      fullName,
      phone: formData.phone,
      email: formData.email,
      class: formData.class,
      stream: formData.stream,
      regarding: formData.regarding,
      message: formData.message,
      submittedAt: serverTimestamp(),
      userId: userId,
    };

    try {
      // 2. Save data to Firestore (Persistent Storage)
      // NOTE: Using a static path 'callbackRequests' as we cannot reliably determine the Canvas App ID here.
      if (db) {
        // NOTE: Using a simple collection path since Canvas environment variables are not used in this model
        const collectionPath = "callbackRequests"; 
        await addDoc(collection(db, collectionPath), submissionData);
      } else {
         console.warn("Firestore not initialized. Skipping persistent data saving.");
      }

      // 3. Send Email Notification (Existing EmailJS)
      const serviceID = "wenvhlv";
      const templateID = "template_wqalhd9"; 
      const publicKey = "nwPm1S8U2W5i1NRsn"; 

      const emailParams = {
        name: fullName,
        email: formData.email,
        message: `Phone: ${formData.phone}\nClass: ${formData.class}\nStream: ${formData.stream}\nRegarding: ${formData.regarding}\n\nMessage: ${formData.message}`,
      };

      await emailjs.send(serviceID, templateID, emailParams, publicKey);
      
      setSuccessMessage("Your callback request has been submitted! We will contact you soon.");
      setFormData({ 
        firstName: "", 
        lastName: "",
        phone: "",
        email: "", 
        class: CLASSES[0], 
        stream: STREAMS[0], 
        regarding: REGARDING_OPTIONS[0],
        message: "" 
      });

    } catch (error) {
      console.error("Error submitting request:", error);
      setErrorMessage("Failed to send request. Please check your network or try again later.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div class="main-contact">

      <div className="contact-container">
      
      <SocialSidebar />
      <div className="form-wrapper">
        <h1 className="form-title">Enquiry or Request a Callback!</h1>
        <p className="form-subtitle">
          We are always here to help you. Fill out the form below and one of our experts will call/message you shortly.
        </p>

        {isSending && (
          <p className="sending-message" ref={sendingRef}>
            Sending<span className="cursor">|</span>
          </p>
        )}

        {successMessage && <p className="success-message animate-message">{successMessage}</p>}
        {errorMessage && <p className="error-message animate-message">{errorMessage}</p>}

        <form onSubmit={handleSubmit} className="contact-form">
          <div className="input-group">
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-group">
            <input
              type="tel"
              name="phone"
              placeholder="Mobile No."
              value={formData.phone}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email Id"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="input-group">
            <div className="select-wrapper">
              <select
                name="stream"
                value={formData.stream}
                onChange={handleChange}
                required
              >
                {STREAMS.map(stream => (
                  <option key={stream} value={stream}>{stream}</option>
                ))}
              </select>
            </div>
            <div className="select-wrapper">
              <select
                name="class"
                value={formData.class}
                onChange={handleChange}
                required
              >
                {CLASSES.map(cls => (
                  <option key={cls} value={cls}>Select Class: {cls}</option>
                ))}
              </select>
            </div>
          </div>
          
          <div className="input-group">
            <div className="select-wrapper">
              <select
                name="regarding"
                value={formData.regarding}
                onChange={handleChange}
                required
              >
                {REGARDING_OPTIONS.map(opt => (
                  <option key={opt} value={opt}>Regarding: {opt}</option>
                ))}
              </select>
            </div>
          </div>

          <textarea
            name="message"
            placeholder="Your Message (Optional)"
            value={formData.message}
            onChange={handleChange}
          ></textarea>
          
          <div className="terms-checkbox">
              <input type="checkbox" id="terms" required />
              <label htmlFor="terms">
                  By submitting this form, I agree to receive all the WhatsApp communication on my registered number and agreeing to PrepX Pathshala's <Link to="/terms-conditions" target="_blank">Terms Of Use</Link> and <Link to="/privacy-policy" target="_blank">Privacy Policy</Link>.
              </label>
          </div>

          <button type="submit" disabled={isSending} className="submit-button-gradient">
            Send Now
          </button>
        </form>

      </div>
      
    </div>
    <Footer />
    </div>
    
  );
};

export default ContactUs;